<template>
  <v-hover v-slot="{ hover }">
    <v-list-item
      v-bind="bindObject"
      class="position-relative text-body-2"
      link
      v-on="$listeners"
    >
      <slot />
      <div v-show="hover" class="list-item-btn-container">
        <v-btn
          v-if="type == 'website'"
          :href="value"
          icon
          link
          target="_blank"
          title="Bấm để mở trang web"
        >
          <v-icon small>mdi-launch</v-icon>
        </v-btn>
        <v-btn
          v-if="type == 'email'"
          :href="`mailto:${value}`"
          icon
          link
          title="Bấm để mail đến địa chỉ này"
        >
          <v-icon small>mdi-email-send-outline</v-icon>
        </v-btn>
        <v-btn
          v-if="type == 'phone'"
          :href="`tel:${value}`"
          icon
          link
          title="Bấm để gọi số điện thoại này"
        >
          <v-icon small>mdi-phone-outline</v-icon>
        </v-btn>
        <v-btn
          v-if="value"
          icon
          title="Bấm để sao chép vào clipboard"
          @click.stop="onCopyToClipboard"
        >
          <v-icon small>mdi-content-copy</v-icon>
        </v-btn>
      </div>
    </v-list-item>
  </v-hover>
</template>

<script>
export default {
  props: { value: {}, type: String },
  computed: {
    isCanClickToCopy() {
      if (!this.value) return false
      if (!this.type) return true
      return ['phone', 'email'].includes(this.type)
    },
    bindObject() {
      if (this.type == 'website') {
        return {
          title: 'Bấm để mở trang',
        }
      }
      return {
        title: this.isCanClickToCopy ? 'Bấm để sao chép vào clipboard' : '',
      }
    },
  },
  methods: {
    onOpenWeb() {
      window.open(this.value, '_blank')
    },
    onCopyToClipboard() {
      const el = document.createElement('textarea')
      el.value = this.value
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      this.$store.dispatch('notify/success', {
        message: 'Sao chép vào clipboard',
      })
    },
  },
}
</script>

<style>
.list-item-btn-container {
  position: absolute;
  top: 5px;
  right: 5px;
  padding-left: 24px;
}
</style>
